import React, { useState, useEffect, useRef, startTransition } from 'react';

import * as moment from 'moment-timezone';

import { Link, withRouter } from 'react-router-dom';

import Layout from '../../components/Layout';
import Swal from "sweetalert2";
import { apiCRMv3 } from '../../services/api';

const ReportDirectMailCrm = (props) => {
    const [showAlert, setShowAlert] = useState(false)
    const [alertTitle, setAlertTitle] = useState('')
    const [alertText, setAlertText] = useState('')
    const [alertVariant, setAlertVariant] = useState('')
    const [fileURLCards, setFileURLCards] = useState('')
    const [fileNameCards, setFileNameCards] = useState('')
    const [loaded, setLoaded] = useState(true)

    const start = useRef(null);
    const end = useRef(null);

    useEffect(function () {
    }, [])

    function onSubmitReportCards(event) {
        event.preventDefault()

        async function getReportDirectMailCrm() {
            try {
                const startValue = start.current.value;
                const endValue = end.current.value;

                const startDate = moment.tz(startValue, "America/Sao_Paulo")
                    .startOf("day")
                    .format("YYYY-MM-DD");

                const endDate = moment.tz(endValue, "America/Sao_Paulo")
                    .endOf("day")
                    .format("YYYY-MM-DD");
                setLoaded(false);
                const response = await apiCRMv3.get(`/direct-mails/export-xlsx`, {
                    params: {
                        start: startDate,
                        end: endDate,

                    },
                    responseType: 'blob'
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `malas_diretas_${startDate}_${endDate}.xlsx`); // nome do arquivo
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);

                Swal.fire("Sucesso!", "O relatório foi baixado com sucesso!", "success");

                setLoaded(true);

            } catch (err) {
                console.log(err);
                Swal.fire("Erro!", "Problemas ao gerar o relatório. Por favor contate o suporte!", "error");
                setLoaded(true);
            }
        }
        getReportDirectMailCrm()
    }

    return (
        <Layout
            menuActive="dashboard"
            pageTitle="Relatório por Data"
        >
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                <small><Link className="label label-default" to="/dashboard">Dashboard</Link></small> <span className="label label-success">Relatório por Data</span>
                            </div>
                        </div>
                        <div className={`card-body table-responsive ${loaded ? "" : "__loading"}`}>
                            <div className="row">
                                <form
                                    onSubmit={onSubmitReportCards}
                                >
                                    <div className="col-xs-3">
                                        <label htmlFor="dtBegin-filter">Data Inicial</label>
                                        <input
                                            className="form-control"
                                            type="date"
                                            id="dtBegin-filter"
                                            ref={start}
                                        />
                                    </div>

                                    <div className="col-xs-3">
                                        <label htmlFor="dtEnd-filter">Data Final</label>
                                        <input
                                            className="form-control"
                                            type="date"
                                            id="dtEnd-filter"
                                            ref={end}
                                        />
                                    </div>

                                    <div className="col-xs-3" style={{ position: 'relative', top: '50%', transform: 'translateY(50%)' }}>
                                        <button
                                            className="btn btn-primary btn-large"
                                            type="submit"
                                        >
                                            Gerar!
                                        </button>
                                    </div>
                                </form>
                            </div>

                            {
                                fileURLCards !== "" ?
                                    <a
                                        href={fileURLCards}
                                        download={fileNameCards}
                                    >
                                        <button
                                            className="btn btn-success btn-large"
                                            type="submit"
                                        >
                                            Download!
                                        </button>
                                    </a>
                                    : null
                            }

                            <br />

                            <div className="loader-container text-center">
                                <div className="icon">
                                    <div className="sk-wave">
                                        <div className="sk-rect sk-rect1"></div>
                                        <div className="sk-rect sk-rect2"></div>
                                        <div className="sk-rect sk-rect3"></div>
                                        <div className="sk-rect sk-rect4"></div>
                                        <div className="sk-rect sk-rect5"></div>
                                    </div>
                                </div>
                                <div className="title">Carregando</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default withRouter(ReportDirectMailCrm)